import { Alert } from "./Alert";

/**
 * Reemplazo de `shared/ui/ErrorAlert.tsx` · usado como `errorComponent` de
 * rutas TanStack Router (patrón documentado en `AGENTS.md`).
 */
export function ErrorAlert({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : "Ocurrió un error inesperado.";
  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <Alert variant="error">Error: {message}</Alert>
    </div>
  );
}
